import React from "react";
import { InspectionTypeMap } from "../../utils/enums";

const AdditionalComments = ({ inspectionType, comments }) => {
  return (
    <div className="section-container">
      <div className="section-header">Additional Inspection Comments</div>

      <div className="info-box">
        <div>
          {comments ||
            `No notes provided by driver at ${InspectionTypeMap[
              inspectionType
            ].toLowerCase()}.`}
        </div>
      </div>
    </div>
  );
};

export default AdditionalComments;
